exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-components-modals-___modalHolder__holder___3mFun {\n    overflow: hidden;\n    display: flex; \n    flex-grow: 1;\n}\n\n.src-components-modals-___modalHolder__exitScreen___3aSyF {\n    display: flex;\n    width: 100%;\n}\n\n.src-components-modals-___modalHolder__modal___14Go9 {\n    display: flex;\n    flex-direction: column;\n    opacity: 0;\n    flex-grow: 1;\n    pointer-events: none;\n    transition: opacity ease-in-out 0.5s;\n    height: 100%;\n}\n\n.src-components-modals-___modalHolder__showModal___3_U3g {\n    opacity: 1;\n    pointer-events: all;\n}\n\n.src-components-modals-___modalHolder__modalAlignTop___1jrdL {\n    justify-content: flex-start;\n}", ""]);

// exports
exports.locals = {
	"holder": "src-components-modals-___modalHolder__holder___3mFun",
	"exitScreen": "src-components-modals-___modalHolder__exitScreen___3aSyF",
	"modal": "src-components-modals-___modalHolder__modal___14Go9",
	"showModal": "src-components-modals-___modalHolder__showModal___3_U3g",
	"modalAlignTop": "src-components-modals-___modalHolder__modalAlignTop___1jrdL"
};